export default "__VITE_ASSET__Bd_MyUg3__"